var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLikeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "favorite/Outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.8,
    d: "M11.9339 20.955L11.9328 20.954C9.12814 18.4107 6.86105 16.3533 5.28611 14.4278C3.71977 12.5128 2.9165 10.8199 2.9165 9.01876C2.9165 6.09631 5.20238 3.81042 8.12484 3.81042C9.78275 3.81042 11.3857 4.58588 12.4288 5.81085C12.5713 5.97818 12.78 6.07459 12.9998 6.07459C13.2196 6.07459 13.4284 5.97818 13.5708 5.81085C14.614 4.58588 16.2169 3.81042 17.8748 3.81042C20.7973 3.81042 23.0832 6.0963 23.0832 9.01876C23.0832 10.8199 22.2799 12.5128 20.7134 14.4293C19.1387 16.3559 16.8723 18.4154 14.0685 20.9633L14.0679 20.9639L14.0663 20.9654L13.0018 21.9271L11.9339 20.955Z",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikeOff);
export default __webpack_public_path__ + "static/media/ic_like_off.f538297f61693c0afc123df6ec74110d.svg";
export { ForwardRef as ReactComponent };